import { action } from 'typesafe-actions';

const entity = 'tickers';

const UPDATE = `${entity}/UPDATE`;
const GET = `${entity}/GET`;

const actionUpdateTickers = (tickers: any) =>
  action(UPDATE, tickers);
const actionGetTickers = (params: any) =>
  action(GET, params);

export {
  UPDATE,
  GET,
  actionUpdateTickers,
  actionGetTickers,
};